'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = events;
exports.isLoaded = isLoaded;
exports.index = index;
exports.geoIndex = geoIndex;
exports.selectRange = selectRange;
exports.setMapCenter = setMapCenter;
exports.setMapView = setMapView;
exports.setRecurrences = setRecurrences;

var _config = require('config');

var _querystring = require('querystring');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GEO_LOAD = 'events/GEO_LOAD';
var GEO_LOAD_FAIL = 'events/GEO_LOAD_FAIL';
var GEO_LOAD_SUCCESS = 'events/GEO_LOAD_SUCCESS';
var LOAD = 'events/LOAD';
var LOAD_FAIL = 'events/LOAD_FAIL';
var LOAD_SUCCESS = 'events/LOAD_SUCCESS';
var SET_MAP_CENTER = 'events/SET_MAP_CENTER';
var SET_MAP_VIEW = 'events/SET_MAP_VIEW';
var SET_RECURRENCES = 'events/SET_RECURRENCES';
var SET_SELECTED_RANGE = 'events/SET_SELECTED_RANGE';

var initialState = {
  data: [],
  geoData: [],
  loaded: false,
  loading: false,
  map: {
    centerLat: _config.app.map.centerLat,
    centerLng: _config.app.map.centerLng,
    initialZoom: _config.app.map.initialZoom
  },
  mapView: false,
  pagination: {
    current_page: null,
    total_pages: null
  },
  promise: null,
  recurrences: true,
  selectedRange: {
    start: null,
    end: null
  }
};

function events() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GEO_LOAD:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true,
        promise: action.promise
      });
    case GEO_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error,
        loaded: false,
        promise: null
      });
    case GEO_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        geoData: action.result.data ? action.result.data : action.result,
        promise: null
      });
    case LOAD:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true,
        promise: action.promise
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error,
        loaded: false,
        promise: null
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        data: action.result.data ? action.result.data : action.result,
        pagination: action.result.meta.pagination ? action.result.meta.pagination : null,
        promise: null
      });
    case SET_MAP_CENTER:
      var map = state.map;
      var nc = action.mapData;

      map.centerLat = nc.center.lat || map.centerLat;
      map.centerLng = nc.center.lng || map.centerLng;
      map.initialZoom = nc.zoom || map.initialZoom;

      return (0, _extends3.default)({}, state, {
        map: map
      });
    case SET_MAP_VIEW:
      return (0, _extends3.default)({}, state, {
        mapView: action.mapView
      });
    case SET_RECURRENCES:
      return (0, _extends3.default)({}, state, {
        recurrences: action.recurrences
      });
    case SET_SELECTED_RANGE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        selectedRange: action.range
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.events && globalState.events.loaded;
}

function index(query) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('calendars/' + process.env.CALENDAR_ID + '/events' + query);
    }
  };
}

function geoIndex(center, radius) {
  var queryRadius = Math.max(100, Math.floor(parseInt(radius, 10)));

  var query = {
    distance: center.lat + ',' + center.lng + ',' + queryRadius,
    per: 1000,
    recurrences: false
  };

  return {
    types: [GEO_LOAD, GEO_LOAD_SUCCESS, GEO_LOAD_FAIL],
    promise: function promise(client) {
      return client.get('calendars/' + process.env.CALENDAR_ID + ('/events?' + (0, _querystring.stringify)(query)));
    }
  };
}

function selectRange(range) {
  return {
    type: SET_SELECTED_RANGE,
    range: range
  };
}

function setMapCenter(mapData) {
  return {
    mapData: mapData,
    type: SET_MAP_CENTER
  };
}

function setMapView(mapView) {
  return {
    type: SET_MAP_VIEW,
    mapView: mapView
  };
}

function setRecurrences(recurrences) {
  return {
    type: SET_RECURRENCES,
    recurrences: recurrences
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/events.js
// module id = 77
// module chunks = 0